<template>
  <v-container class="fill-height pt-0">
    <v-row no-gutters :class="'px-3'">
      <v-col cols="12">
        <v-card-text v-if="dialogMessageTitle" class="text-capitalize pa-0 pb-2 font-weight-bold title text-center" style="white-space: normal">{{ dialogMessageTitle }}</v-card-text>
        <v-card-text class="pa-0 pb-2 mt-0 text-none text-center" v-for="message in dialogMessage" :key="message">{{ message }}</v-card-text>
        <v-row>
          <v-col cols="6" v-for="(button, index) in dialogButton" :key="index" class="mx-auto d-flex justify-center">
            <app-button class="dialog-button" :key="button.title" :title="button.title" :customClass="buttonClass(button)" :action="button.action"></app-button>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" v-for="(attach, index) in dialogAttachments" :key="index" class="mx-auto d-flex justify-center">
            <v-img :src="attach"></v-img>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { locale } from '@/util'
export default {
  name: 'AppPageDialog',
  props: {
    dialogMessageTitle: {
      type: String,
      required: false,
      default: locale.getMessage(`label.system`)
    },
    dialogMessage: {
      type: Array,
      required: false,
      default: () => []
    },
    dialogButton: {
      type: Array,
      required: false,
      default: () => []
    },
    dialogAttachments:{
      type: Array,
      required: false,
      default: () => []
    }
  },
  methods: {
    // With two or more buttons, the dismiss one (Cancel / Close / Not now / Back) is outlined so it never looks like OK
    buttonClass(button) {
      if (button.class) return button.class
      const dismiss = [this.$t(`label.cancel`), this.$t(`button.cancel`), this.$t(`label.close`), this.$t(`label.notNow`), this.$t(`label.back`)]
      if (this.dialogButton.length > 1 && dismiss.includes(button.title)) return 'ng-btn-secondary theme-button'
      return undefined
    }
  }
}
</script>
<style lang="scss">
.text-none {
  text-transform: none;
}
</style>
